import { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { getLocale } from "react-i18nify";

import font from "src/styles/font";
import device from "src/styles/device";
import { checkNotEmpty, convertPrice } from "src/common";

import {
  TextField,
  Autocomplete,
  createFilterOptions,
  InputAdornment,
  Stack,
  IconButton,
} from "@mui/material";

import Button from "src/components/core/Button";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

const Content = styled.div`
  width: 100%;
  overflow-y: auto;
  flex: 1 1 auto;
  -webkit-overflow-scrolling: touch;

  ::-webkit-scrollbar {
    width: 7px;
    height: 5px;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: var(--grey-color);
    border-radius: 100px;
  }
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: var(--grey-color);
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
`;

const Header = styled.div`
  width: 100%;
  padding: 0 24px;
  border-bottom: 10px solid var(--darkwhite-color);
`;

const WrapperHeader = styled.div`
  width: 100%;
  max-width: 530px;
  margin: 0 auto;
`;

const TextLabel = styled.div`
  font-size: ${font.size.md};
  font-weight: 400;
  color: var(--secondary-color);

  ${({ groupItem }) =>
    groupItem &&
    css`
      width: 30%;
      flex: 0 0 30%;

      @media ${device.mobileL} {
        width: 28%;
        flex: 0 0 28%;
      }
    `}

  ${({ totalPrice }) =>
    totalPrice &&
    css`
      font-weight: 600;
      text-align: center;
      width: 40%;
      flex: 0 0 40%;

      @media ${device.mobileL} {
        width: 50%;
        flex: 0 0 50%;
      }
    `}
`;

const TextUnit = styled.div`
  font-size: ${font.size.xs};
  font-weight: 400;
  color: var(--darkgrey-color);
  text-align: right;
  width: 30%;
  flex: 0 0 30%;

  @media ${device.mobileL} {
    width: 22%;
    flex: 0 0 22%;
  }
`;

const WrapperTextfield = styled.div`
  /* width: 100%;
  margin: 24px 0; */

  ${({ groupItem }) =>
    groupItem &&
    css`
      width: 40%;
      flex: 0 0 40%;

      @media ${device.mobileL} {
        width: 50%;
        flex: 0 0 50%;
      }
    `}

  .TextField-without-border-radius fieldset {
    border-radius: 24px;
    // text-align: center;
    // background: #fff;
  }
  .TextField-without-border-radius-amount fieldset {
    border-radius: 24px;
    width: 100%;
    text-align: center;
    background: #fff;
  }
  .MuiAutocomplete-root {
    margin: 0;
  }
  .MuiOutlinedInput-input {
    background: #fff;
    padding: 16px;
    text-align: center;
  }
  .MuiInputBase-root-MuiOutlinedInput-root {
    border-radius: 24px;
    background: #fff;
  }
  .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    border-radius: 24px;
  }

  .MuiTextField-root {
    border-radius: 24px;
  }
  .MuiOutlinedInput-root {
    border-radius: 24px;
  }
  /* .MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {
    padding: 7.5px 0
  } */
`;

const DetailSection = styled.div`
  width: 100%;
  max-width: 578px;
  margin: 0 auto;
  padding: 24px;
`;

const DetailGroup = styled.div`
  width: 100%;
  margin-bottom: 24px;
  display: flex;
  align-items: center;

  :last-child {
    margin-bottom: 0;
  }
`;

const NumberGroup = styled.div`
  display: flex;
  align-items: center;
  width: 40%;
  flex: 0 0 40%;

  .MuiOutlinedInput-root {
    border-radius: 8px;
  }
  .MuiOutlinedInput-input {
    padding: 8px 16px;
    text-align: center;
  }

  @media ${device.mobileL} {
    width: 50%;
    flex: 0 0 50%;
  }
`;

const ButtonGroup = styled(Stack)`
  flex: 0 0 auto;
  width: 100%;
  /* height: max-content; */
  background-color: #fff;
  z-index: 15;
  padding: 32px 24px;
`;

const AddService = ({
  quoList = [],
  serviceData,
  dataServiceType,
  onRemoveElement,
  onSubmit,
  onClose,
  isRemoveDisabled,
}) => {
  const [isEditService, setIsEditService] = useState(false);
  const [selectedService, setSelectedService] = useState({
    service_type: null,
    volume: 0,
    price: 0,
    discount: 0,
    total: 0,
    description: "",
  });

  const submitService = async () => {
    if (quoList[0]?.service_type === null) {
      onRemoveElement(0);
    }

    await onSubmit(selectedService);
    await onClose();
  };

  useEffect(() => {
    if (checkNotEmpty(serviceData)) {
      setSelectedService(serviceData);
      setIsEditService(true);
    }
  }, [serviceData]);

  const filterOptions = createFilterOptions({
    matchFrom: "any",
    limit: 100,
  });

  return (
    <>
      <Content>
        <Header>
          <WrapperHeader>
            <TextLabel>ประเภทการบริการ</TextLabel>

            <WrapperTextfield
              style={{
                width: "100%",
                margin: "24px 0",
              }}
            >
              <Autocomplete
                aria-required={true}
                id="service-type-select"
                isOptionEqualToValue={(option, value) =>
                  option._id === value._id
                }
                renderOption={(props, option) => (
                  <li {...props} key={`service-quotation-${option._id}`}>
                    {`${option?.service_code} (${option?.service_name}/${
                      getLocale() === "th"
                        ? option?.service_unit?.unit_th
                        : option?.service_unit?.unit_en
                    })`}
                  </li>
                )}
                options={dataServiceType}
                value={selectedService?.service_type}
                onChange={(event, newValue) => {
                  setSelectedService((prev) => ({
                    ...prev,
                    service_type: newValue,
                    volume: 1,
                  }));
                }}
                getOptionLabel={(option) => {
                  return `${option?.service_code} (${option?.service_name}/${
                    getLocale() === "th"
                      ? option?.service_unit?.unit_th
                      : option?.service_unit?.unit_en
                  })`;
                }}
                filterOptions={filterOptions}
                sx={{
                  my: 2,
                  width: "100%",
                  background: "#fff",
                  ".MuiOutlinedInput-root": {
                    paddingLeft: "16px",
                  },
                  ".MuiOutlinedInput-input": {
                    textAlign: "left",
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    className="TextField-without-border-radius"
                    {...params}
                    placeholder="เพิ่มการบริการ"
                    error={selectedService?.service_type === null}
                  />
                )}
              />
            </WrapperTextfield>
          </WrapperHeader>
        </Header>

        <DetailSection>
          <DetailGroup>
            <TextLabel groupItem>ราคาติดตั้ง</TextLabel>

            <WrapperTextfield groupItem>
              <TextField
                variant="outlined"
                fullWidth
                sx={{
                  ".MuiOutlinedInput-root": {
                    pl: 0,
                  },
                  ".MuiInputAdornment-root": {
                    position: "absolute",
                    left: "14px",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">฿</InputAdornment>
                  ),
                }}
                value={selectedService?.price}
                onChange={(e) => {
                  if (e.target.value * 0 === 0)
                    setSelectedService((prev) => ({
                      ...prev,
                      price: e.target.value,
                      total:
                        +e.target.value * +selectedService.volume -
                        +selectedService.discount,
                    }));
                }}
                onBlur={(e) => {
                  if (e.target.value * 0 === 0)
                    setSelectedService((prev) => ({
                      ...prev,
                      price: parseFloat(e.target.value) || 0,
                      total:
                        +e.target.value * +selectedService.volume -
                        +selectedService.discount,
                    }));
                }}
                error={selectedService?.price <= 0}
              />
            </WrapperTextfield>

            <TextUnit>
              {selectedService?.service_type !== null
                ? getLocale() === "th"
                  ? `บาท / ${selectedService?.service_type?.service_unit?.unit_th}`
                  : `Baht / ${selectedService?.service_type?.service_unit?.unit_en}`
                : getLocale() === "th"
                  ? `บาท / หน่วย`
                  : `Baht / unit`}
            </TextUnit>
          </DetailGroup>

          <DetailGroup>
            <TextLabel groupItem>จำนวนพื้นที่</TextLabel>

            <NumberGroup>
              <IconButton
                sx={{
                  p: 0.75,
                  borderRadius: 2.5,
                  border: "1px solid var(--lightgrey-color)",
                }}
                disabled={selectedService?.volume < 1}
                onClick={() => {
                  setSelectedService((prev) => ({
                    ...prev,
                    volume: +prev.volume - 1,
                    total:
                      +selectedService.price * (+prev.volume - 1) -
                      +selectedService.discount,
                  }));
                }}
              >
                <RemoveIcon sx={{ color: "var(--darkgreen-color)" }} />
              </IconButton>

              <TextField
                variant="outlined"
                fullWidth
                sx={{
                  mx: 2,
                }}
                value={selectedService?.volume}
                onChange={(e) => {
                  if (e.target.value * 0 === 0)
                    setSelectedService((prev) => ({
                      ...prev,
                      volume: +e.target.value,
                      total:
                        +selectedService.price * +e.target.value -
                        +selectedService.discount,
                    }));
                }}
                error={selectedService?.volume <= 0}
              />

              <IconButton
                sx={{
                  p: 0.75,
                  borderRadius: 2.5,
                  border: "1px solid var(--lightgrey-color)",
                }}
                onClick={() => {
                  setSelectedService((prev) => ({
                    ...prev,
                    volume: +prev.volume + 1,
                    total:
                      +selectedService.price * (+prev.volume + 1) -
                      +selectedService.discount,
                  }));
                }}
              >
                <AddIcon sx={{ color: "var(--darkgreen-color)" }} />
              </IconButton>
            </NumberGroup>

            <TextUnit>
              {selectedService?.service_type !== null
                ? getLocale() === "th"
                  ? `${selectedService?.service_type?.service_unit?.unit_th}`
                  : `${selectedService?.service_type?.service_unit?.unit_en}`
                : getLocale() === "th"
                  ? `หน่วย`
                  : `unit`}
            </TextUnit>
          </DetailGroup>

          <DetailGroup>
            <TextLabel groupItem>ส่วนลด</TextLabel>

            <WrapperTextfield groupItem>
              <TextField
                variant="outlined"
                fullWidth
                sx={{
                  ".MuiOutlinedInput-root": {
                    pl: 0,
                  },
                  ".MuiInputAdornment-root": {
                    position: "absolute",
                    left: "14px",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">฿</InputAdornment>
                  ),
                }}
                value={selectedService?.discount}
                onChange={(e) => {
                  if (e.target.value * 0 === 0)
                    setSelectedService((prev) => ({
                      ...prev,
                      discount: e.target.value,
                      total:
                        +selectedService.price * +selectedService.volume -
                        +e.target.value,
                    }));
                }}
                onBlur={(e) => {
                  if (e.target.value * 0 === 0)
                    setSelectedService((prev) => ({
                      ...prev,
                      discount: parseFloat(e.target.value) || 0,
                      total:
                        +selectedService.price * +selectedService.volume -
                        +e.target.value,
                    }));
                }}
              />
            </WrapperTextfield>

            <TextUnit>บาท</TextUnit>
          </DetailGroup>

          <DetailGroup>
            <TextLabel groupItem>รวมเงิน</TextLabel>

            <TextLabel totalPrice>
              {convertPrice(selectedService?.total)}
            </TextLabel>

            <TextUnit>บาท</TextUnit>
          </DetailGroup>
        </DetailSection>
      </Content>

      <ButtonGroup justifyContent={"center"} alignItems={"center"}>
        <Button
          variant="contained"
          size="large"
          disabled={
            selectedService?.service_type === null ||
            selectedService?.volume === 0 ||
            selectedService?.price === 0
          }
          onClick={() => submitService()}
          sx={{
            width: "100%",
            maxWidth: 350,
            borderRadius: 4,
            py: 1.5,
          }}
        >
          {isEditService ? `Confirm` : `Next`}
        </Button>

        {isEditService ? (
          <Button
            variant="contained"
            size="large"
            disabled={isRemoveDisabled}
            onClick={() => onRemoveElement()}
            sx={{
              width: "100%",
              maxWidth: 350,
              borderRadius: 4,
              py: 1.5,
              mt: 2,
              // boxShadow: "none",
              "&.MuiButton-contained": {
                backgroundColor: "#F7CECB",
                color: "var(--primary-color)",
              },
            }}
          >
            {`Delete`}
          </Button>
        ) : null}
      </ButtonGroup>
    </>
  );
};

export default AddService;
